import { render, staticRenderFns } from "./TrashModal.vue?vue&type=template&id=3a44ab9a&scoped=true&"
import script from "./TrashModal.vue?vue&type=script&lang=js&"
export * from "./TrashModal.vue?vue&type=script&lang=js&"
import style0 from "./TrashModal.vue?vue&type=style&index=0&id=3a44ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a44ab9a",
  null
  
)

export default component.exports